import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './icons';

/** Copies a reference (an ARN) and says so, for screen readers too. */
export function CopyButton({ value, label }: { value: string; label: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);
  return (
    <>
      <button
        type="button"
        className="iconbtn"
        aria-label={t('chat.copy', { label })}
        onClick={() => {
          void navigator.clipboard
            ?.writeText(value)
            .then(() => setCopied(true))
            .catch(() => {});
        }}
      >
        <Icon name={copied ? 'check' : 'copy'} size={18} />
      </button>
      <span className="visually-hidden" role="status">
        {copied ? t('chat.copied') : ''}
      </span>
    </>
  );
}
